<mat-toolbar class="viavi-tabulator-toolbar" *ngIf="showToolbar">
  <mat-toolbar-row>
    <div>
      <button
        mat-stroked-button
        class="filter-btn row-selected-count-button btn-color"
        (click)="removeAllCartData(true)"
        [disabled]="disableRemoveButton()"
        [class.btn-disabled]="disableRemoveButton()"
        *ngIf="cartPage"
      >
        Remove all
      </button>
      <button
        mat-stroked-button
        class="filter-btn row-selected-count-button btn-color"
        (click)="removeAllCartData(false)"
        [class.btn-disabled]="disableUndoButton()"
        [disabled]="disableUndoButton()"
        *ngIf="cartPage"
      >
        Undo all
      </button>
      <button
        mat-stroked-button
        class="clear-filter"
        [ngClass]="isHideClearGroup ? 'filter-btn-group' : ''"
        (click)="toggleFilter($event)"
        *ngIf="isShowClearFilter"
      >
        {{ clearFilterLabel }}
      </button>
      <button
        mat-stroked-button
        class="clear-filter"
        [ngClass]="isHideClearGroup ? 'filter-btn-group' : ''"
        (click)="setGroup($event)"
        *ngIf="isHideClearGroup"
      >
        clear groups
      </button>

      <mat-form-field appearance="none" class="group-chip-list" *ngIf="isHideClearGroup">
        <ng-container *ngIf="isHideClearGroup">
          <mat-chip-list #chipList aria-label="Group Selection">
            <mat-chip
              *ngFor="let data of myGroupBy"
              (removed)="removeGroup(data)"
              class="viavi-table-mat-chip"
            >
              {{ getColumnName(data) }}
              <button matChipRemove>
                <mat-icon>cancel</mat-icon>
              </button>
            </mat-chip>
          </mat-chip-list>
        </ng-container>
      </mat-form-field>
    </div>
    <span class="flexExpand"></span>
    <div class="right-panel-toolbar" *ngIf="!cartPage && isActionEnabled">
      <button
        *ngIf="!cartMode"
        mat-stroked-button
        class="filter-btn row-selected-count-button"
        [class.btn-disabled]="selectedCount < 1"
        (click)="isRefresh ? showAllList() : showSelectedList()"
        [disabled]="selectedCount < 1"
      >
        {{ isRefresh ? 'View all' : 'View items' }}
      </button>

      <ng-container [ngTemplateOutlet]="template"></ng-container>
    </div>
  </mat-toolbar-row>
</mat-toolbar>
<button id="buttontxt" oncontextmenu="event.preventDefault();" style="display: none">
  Button require for triggering the click event programtically
</button>
<input hidden [(ngModel)]="selectedCount" />

<div class="container">
  <div class="filter-controls" id="filter-controls">
    <ng-container *ngIf="!isLoading"> </ng-container>
  </div>
  <span class="tabulator-counter" *ngIf="!isLoading && selectedCount && isActionEnabled"
    >({{ selectedCount }} selected)</span
  >
</div>
